
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { HotLine } from '@Components/Footer/Footer.styled';
import ProfileLayout from '@Components/Layout/profile';
import { Wrapper } from '@Components/ProfilePage/ProfilePage.styled';
import { Title } from '@Components/TermsAndConditions/TermsAndConditions.styled';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Phone from 'public/phone.svg';

type Props = {};

const Services = ({}: Props) => {
  const { t } = useTranslation('common');

  return (
    <ProfileLayout seoData={{ title: t('services') }} hideSideBar={true}>
      <Wrapper
        style={{
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Title
            style={{
              fontSize: '3rem',
            }}
          >
            {t('coming-soon')}
          </Title>
          <HotLine as="a" href="tel:15145">
            <Image src={Phone} width={34} height={34} alt="Phone" />
            <a
              href="tel:15145"
              target="_blank"
              rel="noreferrer noopener"
              className="hotline-num"
              style={{
                color: '#000',
              }}
            >
              15145 <span>{t('hotline')}</span>
            </a>
          </HotLine>
        </div>
      </Wrapper>
    </ProfileLayout>
  );
};

 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default Services;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/services',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  